import { TopBadge } from './TopBadge';
import { onLinkKey } from '../../utils/common/a11y';

export const isHighlightActive = (item) => {
    if (!item?.highlightedUntil) return false;
    const t = new Date(item.highlightedUntil).getTime();
    return Number.isFinite(t) && t > Date.now();
};

const Card = ({
    children,
    isAdditionalAdverts,
    style,
    onClick,
    item,
    isTop,
    dark,
    cabinet,
    extraClass,
}) => {
    const baseClassName = isTop
        ? 'card__payments'
        : isAdditionalAdverts
          ? 'card card__center'
          : dark
            ? 'card card--dark'
            : cabinet
              ? 'card card--cabinet'
              : 'card';
    const highlighted = isHighlightActive(item);
    const classNames = [baseClassName, extraClass, highlighted && 'card--highlighted']
        .filter(Boolean)
        .join(' ');

    const content = (
        <>
            {item && <TopBadge item={item} />}
            {children}
        </>
    );

    if (!onClick) {
        return (
            <div className={classNames} style={style}>
                {content}
            </div>
        );
    }

    const handleClick = (e) => {
        if (e.target.closest('[data-no-card-nav]')) return;
        onClick(e);
    };

    return (
        <div
            className={classNames}
            style={style}
            role="link"
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={onLinkKey(handleClick)}
        >
            {content}
        </div>
    );
};

export default Card;
